<template>
  <div class="policy_list">
    <div class="btn-box">
      <el-button
        type="primary"
        @click="addPolicy"
        size="small"
        v-if="carState && isShowAddBtn"
        >新增保单</el-button
      >
      <el-button
        type="primary"
        @click="addPolicy"
        size="small"
        v-if="!carState && judgePermission('vehicle_insurance_policy_list_create')"
        >新增保单</el-button
      >
      <div>
        <slot></slot>
      </div>
    </div>
    <PolicyHandel
      ref="policyHandel"
      :plateNo="plateNo"
      :type="handelType"
      :editFileList="editFileList"
      :editData="editData"
      @handelSuccess="handleSuccess"
      :plateNoDisabled="!!this.plateNo"
    />

    <!-- 新组件 -->
    <QS-common-table
      :loading="loading"
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      @change="paginationEvent"
      class="mt16"
    >
    </QS-common-table>

    <!-- 删除弹框 -->
    <dialogWrap v-model="delDialogVisible" title="提示" :width="'30%'">
      <span>是否删除该保单?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialogVisible = false">取消</el-button>
        <el-button :loading="deling" type="primary" @click="deleteFun()"
          >删除</el-button
        >
      </span>
    </dialogWrap>
    <PolicyDetail :source="source" :fileList="fileList" ref="PolicyDetailRef" />
    <downloadPolicyPopup ref="downloadPolicyPopupRef" :policyId="policyId" />
  </div>
</template>
<script>
import { policyList, policyDelte } from '@/api/serviceAPi'
import selectOption from '@/store/dict/selectOptionDict'
import PolicyHandel from './policyHandel.vue'
import PolicyDetail from './policyDetail.vue'
import downloadPolicyPopup from '@/components/downloadPolicyPopup/downloadPolicyPopup.vue'
import { operateMaxShowLength } from '@/store/dict/config'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  components: {
    downloadPolicyPopup,
    PolicyHandel,
    PolicyDetail,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    carState: {
      type: [String, Number],
      default: '',
    },
    // 判断是不是车辆详情
    isCarDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      plateNo: 0,
      tableData: [],
      loading: false,

      headColumn: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '保险ID',
            width: 110,
          },
          render: ({ row }) => {
            return (
              <a>
                <span onClick={() => this.change3(row)}>{row.id}</span>
              </a>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
          showColumnItem: !this.isCarDetail,
          render: ({ row }) => {
            return (
              <a class="pointer" style="color: #409eff" onClick={() => this.toCarDetail(row)}>
                {row.carId}
              </a>
            )
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'carModelName',
          columnProps: {
            prop: 'carModelName',
            label: '车型',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'type',
          columnProps: {
            prop: 'type',
            label: '保险类型',
            width: 140,
          },
          getText: ({ row }) => selectOption.insuranceTypeDict[row.type],
        },
        {
          name: 'policyNo',
          columnProps: {
            prop: 'policyNo',
            label: '保单号',
          },
        },
        {
          name: 'premium',
          columnProps: {
            prop: 'premium',
            label: '保费',
          },
          getText: ({ row }) => this.numberWithCommas(row.premium),
        },
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '保单状态',
            width: 100,
          },
          getText: ({ row }) => selectOption.insuranceState[row.state],
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '开始日期',
            width: 110,
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '结束日期',
            width: 110,
          },
        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '保险公司',
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 160,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 120,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            if (
              this.judgePermission('vehicle_insurance_policy_list_download')
            ) {
              result.push({
                name: 'download',
                label: '下载保单附件',
                action: () => this.download(row),
              })
            }
            if (this.judgePermission('vehicle_insurance_policy_list_edit')) {
              result.push({
                name: 'edit',
                label: '编辑',
                action: () => this.change4(row),
              })
            }
            if (this.judgePermission('vehicle_insurance_policy_list_delete')) {
              result.push({
                name: 'dele',
                label: '删除',
                action: () => this.openDel(row),
              })
            }
            return result
          },
        },
      ],
      baseParams: {
        // eslint-disable-next-line vue/no-unused-properties
        destination: 2, //  1-车险管理列表 2-保单管理列表
        // eslint-disable-next-line vue/no-unused-properties
        pageSize: 10,
        // eslint-disable-next-line vue/no-unused-properties
        pageNum: 1,
      },
      delDialogVisible: false,
      deling: false,
      source: {},
      fileList: [], // 详情附件列表
      editFileList: [], // 编辑附件列表
      editData: {}, // 编辑数据
      handelType: 'add', // 操作方式
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      policyId: '',
    }
  },
  computed: {
    isShowAddBtn() {
      return (
        (Number(this.carState) !== 10 ||
          (Number(this.carState) === 10 && this.plateNo)) &&
        Number(this.carState) !== 5 &&
        this.judgePermission('vehicle_insurance_policy_list_create')
      )
    },
  },
  created() {
    this.isCarDetail && this.getList()
    this.plateNo = this.$route.query.plateNo
  },
  watch: {
    loading(val) {
      this.$emit('LoadingChange', val)
    },
  },
  methods: {
    // 跳转车辆详情
    toCarDetail(row) {
      const { carId } = row
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: {
          id: carId,
          source: 'detail',
        },
      })
    },
    download(row) {
      this.policyId = row.id
      this.$refs.downloadPolicyPopupRef.download(row)
    },
    /* 编辑保单按钮 */
    change4(data) {
      this.editData = { ...data }
      this.editFileList = this.getEchoUploadFileData(data.attachment)
      this.plateNo = data?.plateNo || ''
      this.$nextTick(() => {
        this.$refs.policyHandel.handelDialogVisible = true
        this.$refs.policyHandel.setEditData()
        this.handelType = 'edit'
      })
    },
    /* 新增保单按钮 */
    addPolicy() {
      this.$refs.policyHandel.handelDialogVisible = true
      this.handelType = 'add'
      this.plateNo = this.isCarDetail ? this.$route.query.plateNo : ''
    },
    /* 获取列表 */
    async getList() {
      const params = { ...this.baseParams, ...this.params }
      this.loading = true
      try {
        const { code, data } = await policyList(params)
        this.loading = false
        if (code === 1) {
          this.tableData = data.items
          this.paginationData.total = data.totalNum
        }
      } catch {
        this.loading = false
      }
    },
    /* 分页切换 */
    paginationEvent(payload) {
      const { pagination } = payload
      this.paginationData.pageNum = pagination.pageNum
      this.paginationData.pageSize = pagination.pageSize
      // eslint-disable-next-line vue/no-mutating-props
      this.params.pageSize = pagination.pageSize
      // eslint-disable-next-line vue/no-mutating-props
      this.params.pageNum = pagination.pageNum
      this.getList()
    },
    // 删除按钮
    openDel(res) {
      this.delDialogVisible = true
      this.policyId = res.id
    },
    async getDel(res) {
      this.deling = true
      try {
        const data = await policyDelte({
          id: res,
        })
        this.deling = false
        if (data.code === 1) {
          this.$message.success('操作成功')
          this.delDialogVisible = false
          this.sendMessage()
          this.getList()
        }
      } catch (error) {
        this.deling = false
      }
    },
    /* 删除 */
    deleteFun() {
      this.getDel(this.policyId)
    },
    /* ID点击详情 */
    change3(data = {}) {
      this.$refs.PolicyDetailRef.detailDailogVisible = true
      const HS = selectOption.insuranceTypeDict[data.type]
      this.source = {
        ...data,
        // premium: this.numberWithCommas(data.premium)
        premium: data.premium,
      }
      this.source.typeName = HS
      this.fileList = this.getURL({
        data: data.attachment,
        needName: true,
      })
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
    handleSuccess() {
      this.sendMessage()
      this.getList()
    },
  },
}
</script>
<style scoped lang="scss">
.blue {
  color: #2e7eff;
}

.btn-box {
  display: flex;
}
</style>
